import Vue from 'vue';
import getClassNameForExtension from 'font-awesome-filetypes';
import {vueOptions} from '../../main';
import {routeOptions} from '../../assets/js/utils';
import {getDeviceIcon} from '../peers/peer-utils';
import {prompt} from '../Prompt';


const {store, router} = Vue;
const {i18n} = vueOptions;
const tc = i18n.tc.bind(i18n);


export function show(notification) {
  router.push(routeOptions({
    path: '/share/notifications',
    query: {notification: notification.id}
  }));
}


export async function markRead(notification) {
  if (notification.persistent) {
    return;
  }

  if (typeof notification.reject === 'function') {
    notification.reject(new Error('declined'));
  }

  const unsavedFiles = notification.data?.files?.filter((file) => !!file.blob);
  if (unsavedFiles?.length) {
    try {
      await prompt({
        title: 'Nachricht wirklich verwerfen?',
        content: `
          Nachricht enthält ${tc('files', unsavedFiles.length)}, die noch nicht gespeichert wurden.<br>
          Wenn du die Nachricht verwirfst, kannst du die ${tc('files', unsavedFiles.length)} nicht mehr speichern.
        `
      });

    } catch (error) {
      if (error.message === 'declined') {
        show(notification);
      }
      return;
    }
  }
  store.commit('share/removeNotification', notification.id);
}


export function markAllRead(notifications) {
  for (const notification of notifications) {
    markRead(notification);
  }
}


export const props = {
  notification: {
    type: Object,
    default: () => ({})
  },
  secondary: {
    type: Boolean,
    default: false
  },
  detail: {
    type: Boolean,
    default: false
  },
  actions: {
    type: Boolean,
    default: false
  },
  actionsSecondary: {
    type: Boolean,
    default: false
  }
};


/**
 * Get Notification Icon
 *
 * @export
 * @param {Object} notification
 * @return {string} icon
 */
export function icon({type, data}) {
  switch (type.substring(0, type.indexOf('-'))) {
    case 'peer':
      return getDeviceIcon(data?.peer);

    case 'room':
      return 'far fa-stream';

    case 'files':
      return 'far fa-folder-upload';

    case 'file':
      const fileName = data.file.name;
      const extension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
      const className = 'fas ' + getClassNameForExtension(extension);

      return className;

    default:
      return 'far fa-question';
  }
}
